import { render, staticRenderFns } from "./PageInfo.vue?vue&type=template&id=2847ab70&scoped=true"
import script from "./PageInfo.vue?vue&type=script&lang=js"
export * from "./PageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2847ab70",
  null
  
)

export default component.exports